/** 统一外链形态（LeapWorldSDLC-35）：功能页指向外部系统的链接唯一写法——固定新窗口 +
 * noreferrer、主色文字 + 后置外链图标，视觉降级为辅助信息、不与页面主操作争注意力。
 * 命名避开 icons 的 `ExternalLink` 图标；调用方不再自行拼 target/rel/图标。 */
import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { ExternalLink } from './icons'

export type OutboundLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'> & {
  href: string
  children: ReactNode
}

export function OutboundLink({ href, className = '', children, ...props }: OutboundLinkProps) {
  // 截断挂在文本 span 上：匿名 flex 子项（纯文本）出不了省略号（Badge 注释里同一取舍的反向应用）。
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex max-w-full items-center gap-1 text-[var(--color-primary)] hover:underline max-md:min-h-11 ${className}`.trim()}
      {...props}
    >
      <span className="min-w-0 truncate">{children}</span>
      <ExternalLink size={12} className="shrink-0" />
    </a>
  )
}
